import { NgModule } from '@angular/core';
import { SharedModule } from './../shared/shared.module';

import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileComponent } from './profile.component';
import { HeaderComponent } from './header/header.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountFormComponent } from './account-form/account-form.component';
import { ProfileContactFormComponent } from './profile-contact-form/profile-contact-form.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@NgModule({
  declarations: [
    ProfileComponent,
    HeaderComponent,
    ChangePasswordComponent,
    ProfileContactFormComponent,
    AccountFormComponent,
    SidebarComponent,
  ],
  imports: [
    ProfileRoutingModule,
    SharedModule,
  ],
  exports: [
  ]
})
export class ProfileModule { }
